import React from 'react';
import Box from '@bit/knotchinc.web-react-components.box';
import { ErrorIconContainer, StyledErrorIcon, ErrorTitle, ErrorText, ErrorDescriptionContainer } from './styled.js';

const ErrorNoReportData = ({ error }) => (
  <Box p="200px 0" width="100%" height="678px" m="0 auto">
    <ErrorIconContainer height="82px">
      <StyledErrorIcon type="noData" />
    </ErrorIconContainer>
    <ErrorDescriptionContainer width="400px">
      <ErrorTitle uppercase dark>
        {error.title || 'No data found for this report'}
      </ErrorTitle>
      <ErrorText>
        {error.message ||
          "Looks like there isn't enough information to show. Please make sure you've set your competitors or reach out to your Knotch associate."}
      </ErrorText>
    </ErrorDescriptionContainer>
  </Box>
);

export default ErrorNoReportData;
